/*@ngInject*/
const ManageEmailNotificationHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, notificationEmailTemplateRepository, notificationEmailTemplateModel, configurationMediator, coreConstant, modalUtil, notificationPreferencesAction, configurationActionsUtil, loadingBarHandler, navigationStateModel) {

    $element.addClass('manageEmailNotificationHeader');

    this.notificationEmailTemplateModel = notificationEmailTemplateModel;

    this.translations = null;
    this.actions = [];
    this.context = {
        identifier: 'manageEmailNotificationHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};
    this.actionsTimeLastModified = '';

    this.$onInit = function () {
        localization.getTranslationByKey('manageEmailNotificationHeader').then((translations) => {
            this.translations = translations;
            this.actions = [];
            this.loadActions();
        });
    };

    $scope.$on(configurationConstant.event.EMAIL_TEMPLATE_UPDATED, () => {
        this.processActions(this.actions);
    });

    this.loadActions = function () {
        let templateId = $stateParams.templateId;
        if (!templateId) {
            // new template, pass a dummy id
            templateId = -1;
        }

        notificationEmailTemplateRepository.loadActions(templateId).then((actions) => {
            const allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });
            this.actions = allActions;
            this.actionsTimeLastModified = new Date().getTime();
            this.processActions(allActions, false);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === notificationPreferencesAction.SAVE) {
                    action.enabled = notificationEmailTemplateModel.hasUnsavedChanges && notificationEmailTemplateModel.isValid;
                } else if (action.name === notificationPreferencesAction.DISCARD) {
                    action.enabled = notificationEmailTemplateModel.hasUnsavedChanges || !$stateParams.templateId;
                } else if (action.name === notificationPreferencesAction.DELETE) {
                    action.enabled = !_.isEmpty($stateParams.templateId);
                }

                if (action.name === notificationPreferencesAction.SAVE && notificationEmailTemplateModel.hasUnsavedChanges) {
                    this.actionSubTexts[action.name] = {
                        class: 'unsavedChanges',
                        text: _.get(this.translations, 'unsavedChanges')
                    };
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    $scope.$on(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED, () => {
        this.processActions(this.actions);
    });

    this.handleAction = function (action) {
        if (action.enabled) {
            switch (action.name) {
                case notificationPreferencesAction.SAVE:
                    configurationActionsUtil.saveNotificationEmailTemplate(notificationEmailTemplateModel.notificationEmailTemplate).then(function (emailTemplate) {
                        notificationEmailTemplateModel.hasUnsavedChanges = false;
                        if (!_.isNil(emailTemplate)) {
                            $stateParams.templateId = emailTemplate.id;
                        }
                        $state.reload();
                    });
                    break;

                case notificationPreferencesAction.DISCARD:
                    modalUtil.showConfirmationModal(null, null, null, 'manageEmailNotificationHeader.discardConfirmation', null, true, () => {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'discardConfirmation.success'));
                        notificationEmailTemplateModel.hasUnsavedChanges = false;
                        if ($stateParams.templateId) {
                            $state.reload();
                        } else {
                            $state.go('configuration.emailBrowser', {});
                        }
                    });
                    break;

                case notificationPreferencesAction.DELETE:
                    modalUtil.showConfirmationModal(null, null, null, 'manageEmailNotificationHeader.deleteConfirmation', null, true, () => {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'deleteConfirmation.success'));
                        return notificationEmailTemplateRepository.deleteNotificationEmailTemplate(notificationEmailTemplateModel.notificationEmailTemplate.id).then(function () {
                            notificationEmailTemplateModel.hasUnsavedChanges = false;
                            $state.go('configuration.emailBrowser', {});
                        });
                    });
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    this.navigateToEmail = function () {
        $state.go('configuration.emailBrowser', null);
        navigationStateModel.saveViewState('configuration.emailBrowser', null);
    }

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateNotificationEmailTemplateManager = _.startsWith(fromState.name, 'configuration.manageEmail'),
            isTargetSameAsCurrent = toState.name === fromState.name;
        if (toState.name === 'login') {
            return;
        }

        if (notificationEmailTemplateModel.hasUnsavedChanges && isCurrentStateNotificationEmailTemplateManager &&
            !isTargetSameAsCurrent && notificationEmailTemplateModel.notificationEmailTemplate) {
            event.preventDefault();
            if (notificationEmailTemplateModel.isValid) {
                loadingBarHandler.showNotificationLoadingBar(_.get(this.translations, 'saveNotificationEmailTemplate.loadingBar'));
                notificationEmailTemplateRepository.saveNotificationEmailTemplate(notificationEmailTemplateModel.notificationEmailTemplate).then(() => {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'saveNotificationEmailTemplate.savingNotificationEmailTemplateSuccessLoadingBar'));
                    notificationEmailTemplateModel.reset();
                    $state.go(toState, toParams);
                });
            } else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidNotificationEmailTemplate'));
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    });
};

angular.module('ums.configuration')
    .controller('manageEmailNotificationHeaderController', ManageEmailNotificationHeaderController);
